export default __webpack_public_path__ + "static/media/user-icon.a2f8c240.svg";